import { DEFAULT_STATE } from '../constants'

export const initialPricingState = {
  onSale: DEFAULT_STATE.onSale,
  withSubscription: DEFAULT_STATE.withSubscription,
  priceRanges: DEFAULT_STATE.priceRanges,
  minPrice: DEFAULT_STATE.minPrice,
  maxPrice: DEFAULT_STATE.maxPrice,
}
